module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r4r6r9n-1fa9b8d044f5e825cd02d65097ec2512.svg";